<template>
  <div class="rightall">
    <!-- 注册内容 -->

    <div class="Registration-content" v-if="rigestbox">
      <div class="Registrationbox">
        <div class="flex-betweenNowrapAlign pad-bot10">
          <div>
            <img class="logecont" src="@/assets/barsvg/logo-zh@3x.png" alt="" />
          </div>
          <p class="f14 cursorpointer">
            <span>已有账号？</span
            ><span style="color: #52c6cc" @click="topasswotd">返回登录</span>
          </p>
        </div>
        <div class="rigesttit">注册账户</div>
        <div class="width100 pad-bot30" style="background: #fff">
          <div class="topBor width50 margin-auto">
            <el-form :model="inputTo" :rules="rules" class="pad-top20">
              <el-form-item prop="phoneNumber" class="margin-auto buttom-none">
                <el-input
                  size="medium"
                  type="text"
                  v-model="inputTo.phoneNumber"
                  placeholder="手机号码"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="width50 margin-auto">
            <div class="margin-auto flex-betweennowrap">
              <el-input
                size="medium"
                type="text"
                class="el-input width66"
                v-model="registverificationcode"
                placeholder="图形验证码"
              >
              </el-input>
              <img
                class="width27 cursorpointer margin-top10"
                @click="Refresh()"
                :src="img"
                alt=""
              />
            </div>
          </div>
          <div class="pad-top20 width50 margin-auto">
            <div class="margin-auto flex-betweennowrap">
              <el-input
                size="medium"
                type="text"
                class="el-input width66"
                v-model="registSMSverification"
                placeholder="短信验证码"
              >
              </el-input>
              <div
                v-if="changecont"
                class="
                  width27
                  verification
                  color-87
                  lineheight40
                  textalign-center
                  f14
                  cursorpointer
                  margin-top10
                "
                @click="rigestSendSMS()"
              >
                获取验证码
              </div>
              <div
                v-if="changecontspan"
                class="
                  width27
                  verification
                  color-87
                  lineheight40
                  textalign-center
                  f14
                  cursorpointer
                  margin-top10
                "
                @click="rigestSendSMS()"
              >
                重新获取({{ time }}s)
              </div>
            </div>
          </div>
          <div class="width50 margin-auto">
            <el-form :model="inputTo" :rules="rules" class="pad-top20">
              <el-form-item
                prop="Accountpassword"
                class="margin-auto buttom-none"
              >
                <el-input
                  size="medium"
                  show-password
                  type="password"
                  class="el-input pad-bot10"
                  v-model="inputTo.Accountpassword"
                  placeholder="账号密码"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="width50 margin-auto">
            <el-form :model="inputTo" :rules="rules">
              <el-form-item
                prop="Confirmpassword"
                class="margin-auto buttom-none"
              >
                <el-input
                  size="medium"
                  show-password
                  type="password"
                  class="el-input pad-bot10"
                  v-model="inputTo.Confirmpassword"
                  placeholder="确认密码"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="width50 margin-auto">
            <el-form :model="inputTo" :rules="rules">
              <el-form-item
                prop="Enterprisename"
                class="margin-auto buttom-none"
              >
                <el-input
                  size="medium"
                  type="text"
                  v-model="inputTo.Enterprisename"
                  placeholder="企业名称"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <button
            class="
              main-imgt
              textalign-center
              buttom-none
              color-fff
              cursorpointer
            "
            v-if="loginrigest"
            :style="{
              background:
                inputTo.phoneNumber == 0
                  ? '#e7e9ef'
                  : '#52C6CC' && registverificationcode == 0
                  ? '#e7e9ef'
                  : '#52C6CC' && registSMSverification == 0
                  ? '#e7e9ef'
                  : '#52C6CC',
              color:
                inputTo.phoneNumber == 0
                  ? '#969EAC'
                  : '#fff' && registverificationcode == 0
                  ? '#969EAC'
                  : '#fff' && registSMSverification == 0
                  ? '#969EAC'
                  : '#fff',
            }"
            @click="regstbtn()"
          >
            注 册
          </button>
        </div>
        <div class="leftbot">
          <p>
            <span class="pad-right10">{{ author }}</span
            ><span class="pad-right10">{{ icp_number }}</span
            ><span class="pad-right10"> {{ block_chain_number }}</span>
          </p>
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  Getverification,
  SendSMS,
  authloginsms,
  authregister,
  apiconfig,
} from "@/api/login/login.api";

import BUS from "@/BUS/BUS";
import VueCookie from "vue-cookie";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      checked: false,
      rigestbox: true,
      title: "",
      author: "",
      icp_number: "",
      block_chain_number: "",
      inputTo: {
        phonenumber: "",
        phoneNumber: "",
        Accountpassword: "",
        Confirmpassword: "",
        Enterprisename: "",
      },
      registverificationcode: "",
      registSMSverification: "",
      changecont: true,
      changecontspan: false,
      loginrigest: true,
      img: "",
      time: 60,
      rules: {
        phonenumber: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
        ],
        Enterprisename: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 图片验证码刷新
    Refresh() {
      Getverification().then((res) => {
        this.img = res.data.data;
      });
    },
    // 发送注册短信
    rigestSendSMS() {
      if (this.inputTo.phoneNumber == "" || this.registverificationcode == "") {
        return;
      } else {
        // 发送短信
        SendSMS({
          verify_code: this.registverificationcode,
          mobile: this.inputTo.phoneNumber,
        }).then((res) => {
          if (res.data.code == 200) {
            // 成功
            if (res.data.code == 200) {
              this.changecont = false;
              this.changecontspan = true;
              var timer = setInterval(() => {
                this.time--;

                if (this.time == 0) {
                  clearInterval(timer);
                  this.time = 60;
                  Getverification().then((res) => {
                    this.img = res.data.data;
                  });
                  this.verificationcode = null;
                }
              }, 1000);
              this.$message({
                showClose: true,
                message: "获取验证码成功",
                type: "success",
              });
            }
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    // 注册
    regstbtn() {
      authregister({
        mobile: this.inputTo.phoneNumber,
        code: this.registSMSverification,
        password: this.inputTo.Accountpassword,
        confirm_password: this.inputTo.Confirmpassword,
        company: this.inputTo.Enterprisename,
      }).then((res) => {
        if (res.data.code == 200 && res.data.msg == "注册成功") {
          window.localStorage.setItem("token", res.data.data.token);
          window.sessionStorage.setItem("token", res.data.data.token);
          let token = res.data.data.token;
          VueCookie.set("token", token, 14 * 24 * 60 * 60);
          window.sessionStorage.setItem("phon", this.inputTo.phonenumber);
          this.$router.push("/home");
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    topasswotd() {
      BUS.$emit("righten", 222);
    },
  },
  components: {},

  created() {
    // // 获取图片验证码
    Getverification().then((res) => {
      this.img = res.data.data;
    });
    apiconfig({}).then((res) => {
      if (res.data.code == 200) {
        this.title = res.data.data.title;
        this.author = res.data.data.author;
        this.icp_number = res.data.data.icp_number;
        this.block_chain_number = res.data.data.block_chain_number;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {},
};
</script>

<style scoped>
.rightall {
  width: 100%;
  height: 100%;
  background: #f6f7fb;
}
.Registration-content {
  width: 50%;
  margin: auto;
}
.Registrationbox {
  position: relative;
  top: 100px;
}
.logecont {
  width: 120px;
  height: 30px;
}
.rigesttit {
  width: 100%;
  height: 70px;
  line-height: 70px;
  text-align: center;
  font-family: PingFangSC-Medium;
  font-size: 24px;
  color: #ffffff;
  font-weight: 500;
  background: #52c6cc;
  border-radius: 8px 8px 0px 0px;
}
.el-input >>> .el-input__inner {
  border-radius: 4px;
  height: 40px;
  border: 1px solid #efefef;
  outline: none;
  background: #f6f7fb;
  /* line-height: 40px; */
  margin-top: 10px;
}
.main-imgt {
  width: 50%;
  margin: 20px;
  position: relative;
  left: 22.5%;
  height: 46px;
  background: #e7e9ef;
  border-radius: 23px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #969eac;
  text-align: center;
  line-height: 14px;
  font-weight: 500;
}
.verification {
  background: #52c6cc;
  border-radius: 23px;
  color: #fff;
}
.leftbot {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #969eac;
  line-height: 22px;
  font-weight: 400;
  width: 100%;
  margin: auto;
  text-align: center;
  position: relative;
  top: 120px;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>